import { render } from "./FormSelectRegion.vue?vue&type=template&id=0c24ea18&scoped=true&ts=true"
import script from "./FormSelectRegion.vue?vue&type=script&lang=ts"
export * from "./FormSelectRegion.vue?vue&type=script&lang=ts"

import "./FormSelectRegion.vue?vue&type=style&index=0&id=0c24ea18&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c24ea18"]])

export default __exports__